/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Photo_RemoveInputs */

const en_history_photo_remove = /** @type {(inputs: History_Photo_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove photo`)
};

const de_history_photo_remove = /** @type {(inputs: History_Photo_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto entfernen`)
};

/**
* | output |
* | --- |
* | "Remove photo" |
*
* @param {History_Photo_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_photo_remove = /** @type {((inputs?: History_Photo_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Photo_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_photo_remove(inputs)
	return en_history_photo_remove(inputs)
});